var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.68262 5.61523H5.54427H20.4375",
    stroke: "#00648E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5765 5.61588V18.6475C18.5765 19.1412 18.3804 19.6147 18.0312 19.9638C17.6821 20.313 17.2086 20.5091 16.7148 20.5091H7.40657C6.91283 20.5091 6.43931 20.313 6.09019 19.9638C5.74106 19.6147 5.54492 19.1412 5.54492 18.6475V5.61588M8.3374 5.61588V3.75423C8.3374 3.26049 8.53354 2.78697 8.88267 2.43784C9.23179 2.08872 9.70531 1.89258 10.1991 1.89258H13.9224C14.4161 1.89258 14.8896 2.08872 15.2387 2.43784C15.5879 2.78697 15.784 3.26049 15.784 3.75423V5.61588",
    stroke: "#00648E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.1992 10.2695V15.8545",
    stroke: "#00648E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.9219 10.2695V15.8545",
    stroke: "#00648E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.390cce3b9056e12ab682e63a45421293.svg";
export { ForwardRef as ReactComponent };